// extracted by mini-css-extract-plugin
export default {"category":"styles_category__V5n8v","active":"styles_active__n7snn"};